export enum CUSTOM_SWITCH_TYPES {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}
